'use client'

import { useTranslations } from 'next-intl'
import Icon, { IconName } from '@/components/atoms/Icon'
import { Label } from '@/components/atoms/Typography'
import { useToast } from '@/components/molecules/Toast'
import styles from './Share.module.scss'
import { ShareItemProps } from './Share.types'

const buildLink = (href?: string, value?: string) => {
  if (!href) return ''

  return href.replace('{url}', value || '')
}

const ShareItem = ({ type, icon, title, href, value }: ShareItemProps) => {
  const t = useTranslations('General')
  const { success } = useToast()
  const InnerContent = () => (
    <>
      <div className={styles.icon}>
        <Icon iconName={icon as IconName} />
      </div>
      <Label size='xs'>{t(`share.${title}`)}</Label>
    </>
  )

  const handleClick = () => {
    navigator.clipboard.writeText(window.location.href)
    success(t('copyShare'), {
      persistent: false,
    })
  }

  return type === 'link' ? (
    <a
      href={buildLink(href, value)}
      target='_blank'
      className={styles.shareItem}
      rel='noopener noreferrer'
    >
      <InnerContent />
    </a>
  ) : (
    <button
      type='button'
      onClick={handleClick}
      className={styles.shareItem}
    >
      <InnerContent />
    </button>
  )
}

export default ShareItem
